import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CODES } from "../../consts/codes";
import { GetAlarms, ListDownloadAlarm } from "../../services/user/alarmService";

/**
 * Slice de Redux para el estado de alarmas.
 */
export const alarmSlice = createSlice({
  name: "alarm",
  initialState: {
    alarmLoad: [],
    alarmLoadStatus: "fetch",
    alarmDownload: [],
    alarmDownloadStatus: "fetch",
    error: null,
  },
  reducers: {
    /**
     * Reinicia el estado de carga de alarmas.
     */
    resetAlarmLoadState(state, action) {
      state.alarmLoadStatus = "fetch";
    },
    /**
     * Reinicia el estado de descarga de alarmas.
     */
    resetAlarmDownloadState(state, action) {
      state.alarmDownloadStatus = "fetch";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAlarmLoad.pending, (state, action) => {
        state.alarmLoadStatus = "loading";
      })
      .addCase(fetchAlarmLoad.fulfilled, (state, action) => {
        state.alarmLoadStatus = "succeeded";
        state.alarmLoad = action.payload;
      })
      .addCase(fetchAlarmLoad.rejected, (state, action) => {
        state.alarmLoadStatus = "failed";
        state.alarmLoad = [];
      })
      .addCase(fetchAlarmDownload.pending, (state, action) => {
        state.alarmDownloadStatus = "loading";
      })
      .addCase(fetchAlarmDownload.fulfilled, (state, action) => {
        state.alarmDownloadStatus = "succeeded";
        state.alarmDownload = action.payload;
      })
      .addCase(fetchAlarmDownload.rejected, (state, action) => {
        state.alarmDownloadStatus = "failed";
      });
  },
});

/**
 * Obtiene la lista de alarmas cargadas.
 * @param {Object} state - Estado global de Redux.
 * @returns {Array} Lista de alarmas.
 */
export const getAlarmLoad = (state) => state.alarm.alarmLoad;
/**
 * Obtiene el estado de la carga de alarmas.
 * @param {Object} state - Estado global de Redux.
 * @returns {string} Estado de la carga.
 */
export const getAlarmLoadStatus = (state) => state.alarm.alarmLoadStatus;

/**
 * Obtiene la lista de alarmas descargadas.
 * @param {Object} state - Estado global de Redux.
 * @returns {Array} Lista de alarmas descargadas.
 */
export const getAlarmDownload = (state) => state.alarm.alarmDownload;
/**
 * Obtiene el estado de la descarga de alarmas.
 * @param {Object} state - Estado global de Redux.
 * @returns {string} Estado de la descarga.
 */
export const getAlarmDownloadStatus = (state) => state.alarm.alarmDownloadStatus;

export const { resetAlarmLoadState, resetAlarmDownloadState } = alarmSlice.actions;

/**
 * Obtiene las alarmas desde el servidor.
 * @param {Object} data - Parámetros de la consulta.
 * @returns {Promise<Array>} Lista de alarmas.
 */
export const fetchAlarmLoad = createAsyncThunk("alarm/fetchAllAlarmLoad", async (data) => {
  const requestAlarmLoad = await GetAlarms({
    ...data,
  });

  if (
    requestAlarmLoad.status === CODES.COD_RESPONSE_SUCCESS &&
    requestAlarmLoad.data.responseCode === CODES.COD_RESPONSE_SUCCESS
  ) {
    return requestAlarmLoad.data.data;
  }
});

/**
 * Obtiene las alarmas descargadas desde el servidor.
 * @param {Object} data - Parámetros de la consulta.
 * @returns {Promise<Array>} Lista de alarmas descargadas.
 */
export const fetchAlarmDownload = createAsyncThunk("alarm/fetchAllAlarmDownload", async (data) => {
  const requestAlarmDownload = await ListDownloadAlarm({
    ...data,
  });

  if (requestAlarmDownload.status === CODES.COD_RESPONSE_SUCCESS) {
    if (requestAlarmDownload.data.responseCode === CODES.COD_RESPONSE_SUCCESS) {
      return requestAlarmDownload.data.data;
    }
  }
});

/**
 * Reducer de alarmas para el store de Redux.
 */
export default alarmSlice.reducer;